import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { ContactPage } from './pages/ContactPage';
import { GoodsPage } from './pages/GoodsPage';
import { ServicesPage } from './pages/ServicesPage';
import { EventsPage } from './pages/EventsPage';
import { NewsPage } from './pages/NewsPage';
import { LoginPage } from './pages/LoginPage';
import { SignUpPage } from './pages/SignUpPage';
import { ProfilePage } from './pages/ProfilePage';
export function App() {
  return <AuthProvider data-id="element-0">
      <BrowserRouter data-id="element-1">
        <div className="flex flex-col min-h-screen" data-id="element-2">
          <Header data-id="element-3" />
          <div className="flex-1" data-id="element-4">
            <Routes data-id="element-5">
              <Route path="/" element={<HomePage data-id="element-7" />} data-id="element-6" />
              <Route path="/about" element={<AboutPage data-id="element-9" />} data-id="element-8" />
              <Route path="/contact" element={<ContactPage data-id="element-11" />} data-id="element-10" />
              <Route path="/goods" element={<GoodsPage data-id="element-13" />} data-id="element-12" />
              <Route path="/services" element={<ServicesPage data-id="element-15" />} data-id="element-14" />
              <Route path="/events" element={<EventsPage data-id="element-17" />} data-id="element-16" />
              <Route path="/news" element={<NewsPage data-id="element-19" />} data-id="element-18" />
              <Route path="/login" element={<LoginPage data-id="element-21" />} data-id="element-20" />
              <Route path="/signup" element={<SignUpPage data-id="element-23" />} data-id="element-22" />
              <Route path="/profile" element={<ProfilePage data-id="element-25" />} data-id="element-24" />
            </Routes>
          </div>
          <Footer data-id="element-26" />
        </div>
      </BrowserRouter>
    </AuthProvider>;
}